<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view :key="`$route.path${new Date()}`" />
    </keep-alive> -->
    <keep-alive exclude="searchResult">
      <router-view
        v-if="$route.meta.keepAlive != false"
        :key="$route.fullPath"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="$route.meta.keepAlive == false"
      :key="$route.fullPath"
    ></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style>
/*2f75f4*/
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  width: 100%;
  /* height: calc(100vh - 46px); */
  height: 100vh;
  background: #f3f5f7;
  max-width: 500px !important;
  margin: 0 auto;
  min-width: 375px !important;
  overflow: hidden;
  /* padding: 46px 0 0 0;       */
}
@media screen and (min-width: 800px) {
  .van-nav-bar__content {
    width: 800px;
    margin: 0 auto;
  }
}
.van-nav-bar__left,
.van-nav-bar__right {
  padding: 0 6px !important;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.tl {
  text-align: left;
}
.tr {
  text-align: right;
}
.noExceed {
  white-space: nowrap;
  /*设置内容不换行*/
  text-overflow: ellipsis;
  /*设置文字超出文本框的内容显示成...*/
  overflow: hidden;
  /*设置超出隐藏*/
}
.noflex {
  flex: none;
}
.van-nav-bar {
  /* background-color: #000 !important; */
  color: #fff !important;
}
.van-nav-bar__title {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue